export const columns = [
  {
    title: "系统名称",
    width: 150,
    key: "systemName",
    slots: { customRender: "systemName" },
  },{
    title: "材料名称",
    width: 200,
    key: "materialName",
    dataIndex: "materialName",
  },
  {
    title: "规格型号",
    width: 150,
    key: "materialModel",
    dataIndex: "materialModel",
  },
  {
    title: "品牌",
    width: 150,
    key: "materialBrand",
    dataIndex: "materialBrand",
  },
  {
    title: "结算单位",
    width: 150,
    key: "materialUnit",
    dataIndex: "materialUnit",
  },
  {
    title: "订单采购数量",
    width: 150,
    key: "currentOrderCount",
    dataIndex: "currentOrderCount",
  },
  {
    title: "累计已签数量",
    width: 150,
    key: "cumulativeSignCount",
    dataIndex: "cumulativeSignCount",
  },
  {
    title: "采购单价-含税（￥）",
    width: 150,
    key: "taxPrice",
    slots: { customRender: "taxPrice" },
  },
];
